export const translationEngDefault = {
    SkhemataFaqList: {
        "showMoreButton": "Show More...",
    }
};
//# sourceMappingURL=eng.js.map